import { InflateHandle } from './template-inflater';

export interface Public {
    run: (hdl: InflateHandle, filename: string) => Promise<void>;
}

interface Impl extends Public {
    // eslint-disable-next-line @typescript-eslint/no-misused-new
    new (): Impl;
}

// eslint-disable-next-line @typescript-eslint/promise-function-async
const loadModule = (): Promise<Impl> =>
    import(
        /* webpackChunkName: 'app.scorecard.pdf-export' */ './pdf-export.impl'
        /* webpackPrefetch: true */
    ).then((impl) => new (impl.default as any as Impl)());

export class Exporter implements Public {
    private _impl: Impl;

    // eslint-disable-next-line @typescript-eslint/promise-function-async
    run(hdl: InflateHandle, filename: string): Promise<void> {
        if (this._impl) {
            return this._impl.run(hdl, filename);
        }
        return (
            loadModule()
                // eslint-disable-next-line @typescript-eslint/promise-function-async
                .then((impl) => {
                    this._impl = impl;
                    return this._impl.run(hdl, filename);
                })
        );
    }
}
